import axios from 'axios';
import { api_labelflow } from "../../../../config.jsx";

export const getProjectsAPI = (params) =>
    axios.get(`${api_labelflow}/project_management/get_projects`, {
        params: params
    });

export const saveProjectAPI = (params) =>
    axios.post(`${api_labelflow}/project_management/save_project`, params, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

export const editProjectAPI = (params) =>
    axios.put(`${api_labelflow}/project_management/update_one_project`, params);

export const deleteProjectAPI = (params) =>
    axios.delete(`${api_labelflow}/project_management/delete_project`, params);

// NOTE: there is deliberately no `getOneProjectAPI` here. One existed and POSTed to
// `/report_management/send_summary_report` — a route that exists on NEITHER api (grep
// the interface/ dirs). It answered 404, its caller read `data.data.data` off the
// error-shaped body and set the project to `[]`, and nothing reported a thing. The
// backend's own `/project_management/get_one_project` is a stub returning the string
// "success", so there was no correct URL to point it at either. Removed 2026-09-13
// with its caller; write the real endpoint first if a single-project read is wanted.

